/* =====================================================================
   1001 Paillettes — panier AJAX (tiroir latéral)
   Sans JavaScript, les formulaires fonctionnent quand même :
   l'ajout redirige simplement vers la page panier de Shopify.
   ===================================================================== */
(function () {
  const $ = (s) => document.querySelector(s);
  const euros = (cents) => (cents / 100).toFixed(2).replace(".", ",") + " €";

  function toast(msg) {
    const t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("visible");
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove("visible"), 2200);
  }

  function ouvrir() { $("#tiroir").classList.add("ouvert"); $("#voile").classList.add("visible"); }
  function fermer() { $("#tiroir").classList.remove("ouvert"); $("#voile").classList.remove("visible"); }

  function majBadge(count) {
    document.querySelectorAll("[data-badge-panier]").forEach((b) => (b.textContent = count));
  }

  function rendreTiroir(cart) {
    majBadge(cart.item_count);
    const corps = $("#tiroir-corps");
    const pied = $("#tiroir-pied");
    if (!cart.items.length) {
      corps.innerHTML =
        '<div class="panier-vide"><span class="gros" aria-hidden="true">🧵</span>Votre panier est vide pour l\'instant.<br>La boutique n\'attend que vous&nbsp;!</div>';
      pied.style.display = "none";
      return;
    }
    pied.style.display = "block";
    corps.innerHTML = cart.items
      .map(
        (it) => `
      <div class="ligne">
        <div class="mini">${it.image ? `<img src="${it.image}&width=140" alt="">` : ""}</div>
        <div>
          <h4>${it.product_title}</h4>
          ${it.variant_title && it.variant_title !== "Default Title" ? `<div class="pu">${it.variant_title}</div>` : ""}
          <div class="pu">${euros(it.price)} / pièce</div>
          <div class="qte">
            <button data-key="${it.key}" data-q="${it.quantity - 1}" aria-label="Retirer une unité">−</button>
            <span>${it.quantity}</span>
            <button data-key="${it.key}" data-q="${it.quantity + 1}" aria-label="Ajouter une unité">+</button>
          </div>
        </div>
        <div class="droite">
          <span class="total-ligne">${euros(it.final_line_price)}</span>
          <button class="retirer" data-key="${it.key}" data-q="0">Retirer</button>
        </div>
      </div>`
      )
      .join("");
    $("#sous-total").textContent = euros(cart.items_subtotal_price);
  }

  async function chargerPanier() {
    const r = await fetch(window.routes.cart + ".js");
    return r.json();
  }

  async function changerQuantite(key, q) {
    const r = await fetch(window.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: q }),
    });
    rendreTiroir(await r.json());
  }

  /* Ajout au panier : intercepte tous les formulaires produit */
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    try {
      const r = await fetch(window.routes.cartAdd + ".js", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      if (!r.ok) throw new Error();
      toast("Ajouté au panier ✨");
      if (btn) {
        const txt = btn.textContent;
        btn.textContent = "Ajouté ✓";
        btn.classList.add("ok");
        setTimeout(() => { btn.textContent = txt; btn.classList.remove("ok"); }, 1200);
      }
      rendreTiroir(await chargerPanier());
      ouvrir();
    } catch (_) {
      form.submit(); // repli : comportement Shopify standard
    }
  });

  /* Quantités dans le tiroir */
  document.addEventListener("click", (e) => {
    const t = e.target;
    if (t.dataset.key !== undefined && t.dataset.q !== undefined) {
      changerQuantite(t.dataset.key, parseInt(t.dataset.q, 10));
    }
  });

  /* Ouverture / fermeture */
  document.addEventListener("DOMContentLoaded", () => {
    const btnPanier = $("#ouvrir-panier");
    if (btnPanier)
      btnPanier.addEventListener("click", async (e) => {
        e.preventDefault();
        rendreTiroir(await chargerPanier());
        ouvrir();
      });
    const f = $("#fermer-panier");
    if (f) f.addEventListener("click", fermer);
    const v = $("#voile");
    if (v) v.addEventListener("click", fermer);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") fermer(); });
  });
})();
